import { Flex } from '@gmg/gmg-react-components';
import { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import WrappedSpinner from 'src/shared/WrappedSpinner';

interface SignedUpProps { };

// This component is designed to display a loading indicator while gathering necessary information
// before redirecting the user to a protected route within the application.
// We need to redirect the user to the page the user was trying to access before the user signed up.
// AWS Amplify Auth does not provide a way to redirect the user to the page the user was trying to access before the user signed up.
const SignedUp: FunctionComponent<SignedUpProps> = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const stateParam = searchParams.get('state');

    useEffect(() => {
        if (stateParam) {
            try {
                const { redirectTo } = JSON.parse(decodeURIComponent(stateParam));
                navigate(redirectTo);
            } catch (error) {
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateParam]);

    return (
        <Flex alignItems='center' justifyContent='center' height='100vh'>
            <WrappedSpinner label={t('Common.Spinner', 'Loading...')} labelPosition="bottom" />
        </Flex>
    );
};


export default SignedUp;